const prodBaseUrl = process.env.VUE_APP_BASE_URL || process.env.VUE_APP_URL || 'https://api.dintekco.cn'
const env = process.env.NODE_ENV === 'development' ? 'development' : 'production'

const configMap = {
  development: {
    baseUrl: '/api',
    h5SecureEnabled: true,
  },
  production: {
    baseUrl: prodBaseUrl,
    h5SecureEnabled: true,
  },
}

const config = configMap[env]

export const baseUrl = config.baseUrl
export const h5SecureEnabled = config.h5SecureEnabled

export default config
